import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import {connect} from 'react-redux';
import Const from 'constants';

class LineupPlayerFinalTableRowComponent extends Component {
    canComponentBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isModeBacktest();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const {points} = this.props;

        return <td>{points}</td>;
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

const LineupPlayerFinalTableRow = connect(mapStatesToProps)(LineupPlayerFinalTableRowComponent);

export {LineupPlayerFinalTableRow};
